import React, { useEffect, useState } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import { useNavigate, useParams } from "react-router-dom";
import { FaHouseUser, FaRegMoneyBillAlt, FaTruck, FaUserAlt } from "react-icons/fa";
import { GrDocumentUser } from "react-icons/gr";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { MdFormatListNumberedRtl } from "react-icons/md";
import ListaMovimentos from "../../Componentes/ListaMovimento";
import "./styles.css";

const dadosIniciaisVisita = {
  Visita: {
    IDvisita: 0,
    cliente: {
      cliente: "-",
      cpf_cnpj: "-",
      observacao: "-",
      endereco: {
        IDendereco: 0,
        cep: "-",
        IDlogradouro: 0,
        logradouro: "-",
        numero: "-",
        complemento: null,
        bairro: "-",
        cidade: "-",
        uf: "-",
        tipo: "",
      },
    },
    lote: {
      IDlote: 0,
      IDUsuario: 0,
      IDveiculo: 0,
      datahora: "",
      situacao: 0,
      nomeUsuario: "-",
      modeloVeiculo: "-",
      placaVeiculo: "-",
      totalVisitas: 0,
    },
    quantidade: "0.00",
    valor: "0.00",
    situacao: 0,
    observacao: null,
    assinatura: null,
  },
};

const Visita = () => {
  const { IDmotorista, IDvisita } = useParams();
  const [, setDadosMotorista] = useState([]);
  const [nomeMotorista, setNomeMotorista] = useState("-");
  const [veiculoMotorista, setVeiculoMotorista] = useState("-");
  const [listaMov, setListaMov] = useState({ resultMovimentos: [] });
  const [dadosVisita, setDadosVisita] = useState(dadosIniciaisVisita);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
    carregaDadosMotorista(IDmotorista);
  }, [IDmotorista, navigate]);

  useEffect(() => {
    carregaDadosVisita(IDvisita);

    const intervalo = setInterval(() => {
      carregaDadosVisita(IDvisita);
    }, 60000);

    return () => clearInterval(intervalo);
  }, [IDvisita]);

  async function carregaDadosVisita(idvisita) {
    const retorno = await buscaDadosVisitas(idvisita);
    if (retorno?.data) {
      setDadosVisita(retorno.data);
    }

    const dadosMovim = await buscaDadosMovimentos(idvisita);
    if (dadosMovim?.data?.Movimentos) {
      setListaMov(dadosMovim.data.Movimentos);
    }
  }

  async function carregaDadosMotorista(id) {
    const retorno = await buscaMotorista(id);
    if (retorno?.data) {
      setDadosMotorista(retorno.data);
      setNomeMotorista(
        `${String(retorno.data.Usuario.IDusuario).padStart(6, "0")} | ${
          retorno.data.Usuario.pessoa.nome
        } | CPF: ${formatCPF(retorno.data.Usuario.pessoa.cpf)}`
      );
      if (retorno.data.Usuario.veiculo) {
        setVeiculoMotorista(
          `${retorno.data.Usuario.veiculo[0].modelo} | ANO: ${retorno.data.Usuario.veiculo[0].ano_modelo} | PLACA: ${retorno.data.Usuario.veiculo[0].placa}`
        );
      }
    }
  }

  async function buscaDadosVisitas(id) {
    try {
      return await api.get(`/visita/${id}`);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async function buscaDadosMovimentos(idvisita) {
    try {
      return await api.get(`/movimentos/last/${idvisita}`);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async function buscaMotorista(id) {
    try {
      return await api.get(`/usuario/${id}`);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  function formatCPF(cpf) {
    const cpfLimpo = cpf.replace(/\D/g, "");
    if (cpfLimpo.length !== 11) {
      return cpf;
    }
    return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  const endereco = dadosVisita.Visita.cliente.endereco;
  const enderecoCompleto = `${endereco.tipo || ""} ${endereco.logradouro || ""}, ${
    endereco.numero || "-"
  } ${endereco.complemento || ""}, ${endereco.bairro || "-"} - ${
    endereco.cidade || "-"
  }/${endereco.uf || "-"}`.replace(/\s+/g, " ").trim();

  const valorVisita = Number(dadosVisita.Visita.valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return (
    <div className="menu-container-visita">
      <MenuLateral />

      <div id="painel_principal_visita">
        <div className="visita-page-header">
          <div className="visita-page-title-wrap">
            <div className="visita-page-title-row">
              <span className="visita-page-kicker">Detalhes da visita</span>
              <h1 className="visita-page-title">
                Visita n° {String(IDvisita).padStart(5, "0")}
              </h1>
            </div>
          </div>
        </div>

        <div id="painel_visita">
          <div className="visita-driver-grid">
            <div className="visita-driver-card">
              <p className="visita-label">
                <FaUserAlt /> Motorista
              </p>
              <p className="visita-value">{nomeMotorista}</p>
            </div>
            <div className="visita-driver-card">
              <p className="visita-label">
                <FaTruck /> Veiculo
              </p>
              <p className="visita-value">{veiculoMotorista}</p>
            </div>
          </div>
        </div>

        <div id="div_painel_visita">
          <div className="visita-summary-grid">
            <div className="visita-summary-card">
              <p className="visita-label">
                <FaUserAlt /> Cliente
              </p>
              <p className="visita-value">{dadosVisita.Visita.cliente.cliente}</p>
            </div>

            <div className="visita-summary-card">
              <p className="visita-label">
                <GrDocumentUser /> CNPJ/CPF
              </p>
              <p className="visita-value">{dadosVisita.Visita.cliente.cpf_cnpj}</p>
            </div>

            <div className="visita-summary-card visita-summary-card-wide">
              <p className="visita-label">
                <HiOutlineInformationCircle /> Observacoes do cliente
              </p>
              <p className="visita-value">
                {dadosVisita.Visita.cliente.observacao || "-"}
              </p>
            </div>

            <div className="visita-summary-card visita-summary-card-full">
              <p className="visita-label">
                <FaHouseUser /> Endereco
              </p>
              <p className="visita-value">{enderecoCompleto}</p>
            </div>

            <div className="visita-summary-card">
              <p className="visita-label">
                <MdFormatListNumberedRtl /> Quantidade
              </p>
              <p className="visita-value">{dadosVisita.Visita.quantidade}</p>
            </div>

            <div className="visita-summary-card">
              <p className="visita-label">
                <FaRegMoneyBillAlt /> Valor
              </p>
              <p className="visita-value">{valorVisita}</p>
            </div>

            <div className="visita-summary-card visita-summary-card-wide">
              <p className="visita-label">
                <HiOutlineInformationCircle /> Observacoes da visita
              </p>
              <p className="visita-value">{dadosVisita.Visita.observacao || "-"}</p>
            </div>

          </div>

          <div className="visita-bottom-grid">
            {dadosVisita.Visita.assinatura && (
              <div className="visita-summary-card visita-signature-card">
                <p className="visita-label">Assinatura</p>
                <img
                  src={dadosVisita.Visita.assinatura}
                  alt="Assinatura"
                  className="visita-signature-image"
                />
              </div>
            )}

            <div className="visita-movements-section">
              <div className="visita-section-header">
                <span className="visita-section-kicker">Linha do tempo</span>
                <h2 className="visita-section-title">Movimentos da visita</h2>
              </div>
              <div id="painelMovimentos">
                <ListaMovimentos listaMovimento={listaMov} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Visita;
